import axios from '@axios'

export default {
    namespaced: true,
    state: {
        personas: [],
        tipoEmpresa: [],
        paises: [],
        provincias: [],
        ciudades: [],
        tipos: [],
        provee: [],
        grupos: [],
        vendedores: [],
        canales: [],
        bancos: [],
        categoriaCliente: [],
        cuentas: [],
        tipo: [],
        tipoCliente: [],
        zonas: [],
        subtipo: [],
        formasPago: [],
        categorias: [],
        estadoCivil: [],
        generos: [],
        tiposIdentificacion: [],
        ciudadesXprovinciaPais: [],
        entidades: [],
        entidadesXid: [],
        categoriasXpermiso: [],
        grupoEconomico: [],

        bancosProveedor: [],
        cargarProveedorLocal: [],
        cargarDivision: [],
        tipoPG: [],
        checkProveedor: [],
        division: [],

        AgregarProveedorLocal: [],
        EntidadesProveedorLocal: [],
        EntidadesProveedorLocalCuenta: [],
        InfoProveedorLocal: [],
        AgregarCuenta: [],

        serie: [],

        entidadesClientesLocales: [],
        clientesLocales: [],
        infoClienteLocal: [],
        entidadesAll: [],
        categoriasPG: [],
        proveedoresLocales: [],
    },
    getters: {
        getPersonas(state) {
            return state.personas
        },
        getCategorias(state) {
            return state.categorias
        },
        getTipoEmpresa(state) {
            return state.tipoEmpresa
        },
        getPaises(state) {
            return state.paises
        },
        getProvincias(state) {
            return state.provincias
        },
        getCiudades(state) {
            return state.ciudades
        },
        getGrupos(state) {
            return state.grupos
        },
        getCanales(state) {
            return state.canales
        },
        getCuentas(state) {
            return state.cuentas
        },
        getZonas(state) {
            return state.zonas
        },
        getProvee(state) {
            return state.provee
        },
        getBancos(state) {
            return state.bancos
        },
        getCategoriasCliente(status) {
            return status.categoriaCliente
        },
        getTiposCliente(state) {
            return state.tipoCliente
        },
        getSubCanales(state) {
            return state.subtipo
        },
        getFormasPago(state) {
            return state.formasPago
        },
        getVendedores(state) {
            return state.vendedores
        },
        getEstadoCivil(state) {
            return state.estadoCivil
        },
        getCiudadesXprovinciaPais(state) {
            return state.ciudadesXprovinciaPais
        },
        getGeneros(state) {
            return state.generos
        },
        getTiposIdentificacion(state) {
            return state.tiposIdentificacion
        },
        getEntidades(state) {
            return state.entidades
        },
        getCategoriasXpermiso(state) {
            return state.categoriasXpermiso
        },
        getGrupoEconomico(state) {
            return state.grupoEconomico
        },
        getEntidadesXid(state) {
            return state.entidadesXid
        },

        getCargarProveedorLocal(state) {
            return state.cargarProveedorLocal
        },

        getBancosProveedor(state) {
            return state.bancosProveedor
        },
        getCargarDivision(state) {
            return state.cargarDivision
        },
        getTipoPG(state) {
            return state.tipoPG
        },

        getDivision(state) {
            return state.division
        },

        getCheckProveedor(state) {
            return state.checkProveedor
        },

        getEntidadesProveedorLocal(state) {
            return state.EntidadesProveedorLocal
        },

        getEntidadesProveedorLocalCuenta(state) {
            return state.EntidadesProveedorLocalCuenta
        },

        getInfoProveedorLocal(state) {
            return state.InfoProveedorLocal
        },

        getSerie(state) {
            return state.serie
        },

        getProveedoresLocales(state) {
            return state.proveedoresLocales
        },

        getEntidadesClientesLocales(state) {
            return state.entidadesClientesLocales
        },
        getClientesLocales(state) {
            return state.clientesLocales
        },
        getInfoClienteLocal(state) {
            return state.infoClienteLocal
        },
        getEntidadesAll(state) {
            return state.entidadesAll
        },
        getCategoriasPG(state) {
            return state.categoriasPG
        },
    },
    mutations: {
        setTipoEmpresa(state, tipoEmpresa) {
            state.tipoEmpresa = tipoEmpresa
        },
        setPersonas(state, personas) {
            state.personas = personas
        },
        setPaises(state, paises) {
            state.paises = paises
        },
        setProvincias(state, provincias) {
            state.provincias = provincias
        },
        setCiudades(state, ciudades) {
            state.ciudades = ciudades
        },
        setTipos(state, tipos) {
            state.tipos = tipos
        },
        setEstadoPersona(state, Codigo) {
            const persona = state.personas.find(p => p.Codigo === Codigo)
            persona.Estado = 'Inactivo'
        },
        setProvee(state, provee) {
            state.provee = provee
        },
        setGrupos(state, grupos) {
            state.grupos = grupos
        },
        setVendedores(state, vendedores) {
            state.vendedores = vendedores
        },
        setCanales(state, canales) {
            state.canales = canales
        },
        setBancos(state, bancos) {
            state.bancos = bancos
        },
        setCategoriasCliente(state, categoriaCliente) {
            state.categoriaCliente = categoriaCliente
        },
        setCuentas(state, cuentas) {
            state.cuentas = cuentas
        },
        setTipos(state, tipo) {
            state.tipo = tipo
        },
        setTiposClientes(state, tipoCliente) {
            state.tipoCliente = tipoCliente
        },
        setZonas(state, zonas) {
            state.zonas = zonas
        },
        setSubTipos(state, subtipo) {
            state.subtipo = subtipo
        },
        setFormasPago(state, formasPago) {
            state.formasPago = formasPago
        },
        setCategorias(state, categorias) {
            state.categorias = categorias
        },
        setTiposIdentificacion(state, tiposIdentificacion) {
            state.tiposIdentificacion = tiposIdentificacion
        },
        setEstadoCivil(state, estadoCivil) {
            state.estadoCivil = estadoCivil
        },
        setGeneros(state, generos) {
            state.generos = generos
        },
        setCiudadesXprovinciaPais(state, ciudadesXprovinciaPais) {
            state.ciudadesXprovinciaPais = ciudadesXprovinciaPais
        },
        setEntidades(state, entidades) {
            state.entidades = entidades
        },
        setCategoriasXpermiso(state, categoriasXpermiso) {
            state.categoriasXpermiso = categoriasXpermiso
        },
        setGrupoEconomico(state, grupoEconomico) {
            state.grupoEconomico = grupoEconomico
        },
        setEntidadesXid(state, entidadesXid) {
            state.entidadesXid = entidadesXid
        },

        setBancosProveedor(state, bancosProveedor) {
            state.bancosProveedor = bancosProveedor
        },

        setCargarProveedorLocal(state, cargarProveedorLocal) {
            state.cargarProveedorLocal = cargarProveedorLocal
        },
        setCargarDivision(state, cargarDivision) {
            state.cargarDivision = cargarDivision
        },
        setTipoPG(state, tipoPG) {
            state.tipoPG = tipoPG
        },
        setDivision(state, division) {
            state.division = division
        },
        setCheckProveedor(state, checkProveedor) {
            state.checkProveedor = checkProveedor
        },

        setEntidadesProveedorLocal(state, EntidadesProveedorLocal) {
            state.EntidadesProveedorLocal = EntidadesProveedorLocal
        },

        setEntidadesProveedorLocalCuenta(state, EntidadesProveedorLocalCuenta) {
            state.EntidadesProveedorLocalCuenta = EntidadesProveedorLocalCuenta
        },
        setInfoProveedorLocal(state, InfoProveedorLocal) {
            state.InfoProveedorLocal = InfoProveedorLocal
        },
        setSerie(state, serie) {
            state.serie = serie
        },

        setProveedoresLocales(state, proveedoresLocales) {
            state.proveedoresLocales = proveedoresLocales
        },

        setEntidadesClientesLocales(state, entidadesClientesLocales) {
            state.entidadesClientesLocales = entidadesClientesLocales
        },
        setClientesLocales(state, clientesLocales) {
            state.clientesLocales = clientesLocales
        },
        setInfoClienteLocal(state, infoClienteLocal) {
            state.infoClienteLocal = infoClienteLocal
        },
        setEntidadesAll(state, entidadesAll) {
            state.entidadesAll = entidadesAll
        },
        setCategoriasPG(state, categoriasPG) {
            state.categoriasPG = categoriasPG
        },
    },
    actions: {
        fetchProveedoresLocales({ commit }, data) {
            if (!data) {
                return new Promise((resolve, reject) => {
                    axios
                        .get('/api/auth/personas/proveedores-locales')
                        .then(response => {
                            commit('setProveedoresLocales', response.data)
                            resolve(response.data)
                        })
                        .catch(error => {
                            reject(error)
                        })
                })
            } else {
                return new Promise((resolve, reject) => {
                    axios
                        .get('/api/auth/personas/proveedores-locales', {
                            params: {
                                paginated: data.paginated,
                                search: data.search,
                                rangoFecha: data.rangoFecha,
                                perPage: data.pagination?.perPage,
                                page: data.pagination?.currentPage,
                            },
                        })
                        .then(response => {
                            commit('setProveedoresLocales', response.data)
                            resolve(response.data)
                        })
                        .catch(error => {
                            reject(error)
                        })
                })
            }
        },

        fetchCategorias({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/categorias')
                    .then(response => {
                        commit('setCategorias', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTipoEmpresa({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/tipoEmpresa')
                    .then(response => {
                        commit('setTipoEmpresa', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPersonas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas', { params: data })
                    .then(response => {
                        commit('setPersonas', response.data.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPaises({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/paises')
                    .then(response => {
                        commit('setPaises', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchProvincias({ commit }, provincia_id) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/personas/provincias?provincia_id=${provincia_id}`
                axios
                    .get(url)
                    .then(response => {
                        commit('setProvincias', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCiudades({ commit }, ciudad_id) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/personas/ciudades?ciudad_id=${ciudad_id}`
                axios
                    .get(url)
                    .then(response => {
                        commit('setCiudades', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTipos({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/tipos')
                    .then(response => {
                        commit('setTipos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFormasPago({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/formasPago')
                    .then(response => {
                        commit('setFormasPago', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchGrupos({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/grupos')
                    .then(response => {
                        commit('setGrupos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        clearProvincias({ commit }) {
            commit('setProvincias', [])
        },
        clearCiudades({ commit }) {
            commit('setCiudades', [])
        },
        crearPersona({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/personas/crear', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        editarPersona({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/personas/editar', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        eliminarPersona({ commit }, Codigo) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/personas/eliminarPersona', { Codigo: Codigo })
                    .then(response => {
                        commit('setEstadoPersona', Codigo)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        eliminarCliSri({ commit }, Id) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/personas/eliminarCliSri', { Id: Id })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        eliminarProvSri({ commit }, Id) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/personas/eliminarProvSri', { Id: Id })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        eliminarSucursal({ commit }, co_sucursal) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/personas/eliminarSucursal', { co_sucursal: co_sucursal })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPersona({ commit }, Codigo) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/personas/persona/${Codigo}`
                axios
                    .get(url)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchSucursal({ commit }, Codigo) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/personas/sucursal/${Codigo}`
                axios
                    .get(url)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCliente({ commit }, Codigo) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/personas/cliente/${Codigo}`
                axios
                    .get(url)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchProveedor({ commit }, Codigo) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/personas/proveedor/${Codigo}`
                axios
                    .get(url)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchVendedor({ commit }, Codigo) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/personas/vendedor/${Codigo}`
                axios
                    .get(url)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchComprador({ commit }, Codigo) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/personas/comprador/${Codigo}`
                axios
                    .get(url)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEmpresa({ commit }, Codigo) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/personas/empresa/${Codigo}`
                axios
                    .get(url)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPropietario({ commit }, Codigo) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/personas/propietario/${Codigo}`
                axios
                    .get(url)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchChofer({ commit }, Codigo) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/personas/chofer/${Codigo}`
                axios
                    .get(url)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchGuardia({ commit }, Codigo) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/personas/guardia/${Codigo}`
                axios
                    .get(url)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTecnico({ commit }, Codigo) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/personas/tecnico/${Codigo}`
                axios
                    .get(url)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchProvee({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/provee/')
                    .then(response => {
                        commit('setProvee', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchVendedores({ commit }, data) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/personas/vendedores?page=${data['page']}`
                if (data['nombre']) {
                    url += `&nombre=${data['nombre']}`
                }
                if (data['cedula']) {
                    url += `&cedula=${data['cedula']}`
                }
                axios
                    .get(url)
                    .then(response => {
                        commit('setVendedores', response.data.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCanales({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/canales')
                    .then(response => {
                        commit('setCanales', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchBancos({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/bancos')
                    .then(response => {
                        commit('setBancos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCategoriasCliente({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/categoriasCliente')
                    .then(response => {
                        commit('setCategoriasCliente', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCuentas({ commit }, data) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/personas/cuentas`
                if (data['codigo']) {
                    url += `?codigo=${data['codigo']}`
                }
                if (data['nombre']) {
                    url += `?nombre=${data['nombre']}`
                }
                axios
                    .get(url)
                    .then(response => {
                        commit('setCuentas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchTipo({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/tipo')
                    .then(response => {
                        commit('setTipos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchTipoCliente({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/tipoCliente')
                    .then(response => {
                        commit('setTiposClientes', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchZonas({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/zonas')
                    .then(response => {
                        commit('setZonas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchSubtipo({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/subtipo')
                    .then(response => {
                        commit('setSubTipos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchChequeoPersonal({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/productoTerminado/checkPersonal', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTiposIdentificacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/tiposIdentificacion', { params: data })
                    .then(response => {
                        commit('setTiposIdentificacion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEstadoCivil({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/estadoCivil')
                    .then(response => {
                        commit('setEstadoCivil', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchGeneros({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/generos')
                    .then(response => {
                        commit('setGeneros', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCiudadesXprovinciaPais({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/ciudadesXprovinciaPais', { params: data })
                    .then(response => {
                        commit('setCiudadesXprovinciaPais', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postAgregarEntidad({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/personas/agregarEntidad', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEditarEntidad({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/personas/editarEntidad', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postAnularEntidad({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/personas/anularEntidad', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        verificarEntidad({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/personas/verificarEntidad', { params: data })
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchEntidades({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/entidades', { params: data })
                    .then(response => {
                        commit('setEntidades', response.data.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCategoriasXpermiso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/categoriasXpermiso', { params: data })
                    .then(response => {
                        commit('setCategoriasXpermiso', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchGrupoEconomico({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/grupoEconomico')
                    .then(response => {
                        commit('setGrupoEconomico', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEntidadesXid({ commit }, id_entidad) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/personas/entidadesXid/${id_entidad}`)
                    .then(response => {
                        commit('setEntidadesXid', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchBancosProveedor({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/getBancosProveedor', { params: data })
                    .then(response => {
                        commit('setBancosProveedor', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCargarProveedorLocal({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/CargarProveedorLocal', { params: data })
                    .then(response => {
                        commit('setCargarProveedorLocal', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCargarDivision({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/CargarDivision', { params: data })
                    .then(response => {
                        commit('setCargarDivision', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchTipoPG({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/getTipoPG', { params: data })
                    .then(response => {
                        commit('setTipoPG', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchDivision({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/getDivision', { params: data })
                    .then(response => {
                        commit('setDivision', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCheckProveedor({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/CheckProveedor', { params: data })
                    .then(response => {
                        commit('setCheckProveedor', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAgregarProveedorLocal({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/personas/AgregarProveedorLocal', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAgregarCuenta({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/personas/AgregarCuenta', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEliminarProveedorLocal({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/personas/EliminarProveedorLocal', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEliminarCuenta({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/personas/EliminarCuenta', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEditarProveedorLocal({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/personas/EditarProveedorLocal', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEditarCuenta({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/personas/EditarCuenta', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEntidadesProveedorLocal({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/getEntidadesProveedorLocal', { params: data })
                    .then(response => {
                        commit('setEntidadesProveedorLocal', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEntidadesProveedorLocalCuenta({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/getEntidadesProveedorLocalCuenta', { params: data })
                    .then(response => {
                        commit('setEntidadesProveedorLocalCuenta', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchLLenarData({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/personas/LLenarData', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchInfoProveedorLocal({ commit }, idEntidad) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/getInfoProveedorLocal/' + idEntidad)
                    .then(response => {
                        commit('setInfoProveedorLocal', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchSerie({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/getSerie', { params: data })
                    .then(response => {
                        commit('setSerie', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAgregarSerie({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/personas/AgregarSerie', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEliminarSerie({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/personas/EliminarSerie', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEntidadesClientesLocales({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/entidadesClientesLocales')
                    .then(response => {
                        commit('setEntidadesClientesLocales', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEntidadesAll({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/entidadesAll', { params: data })
                    .then(response => {
                        commit('setEntidadesAll', response.data.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchClientesLocales({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/clientesLocales')
                    .then(response => {
                        commit('setClientesLocales', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchInfoClienteLocal({ commit }, idEntidad) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/clientesLocales/' + idEntidad)
                    .then(response => {
                        commit('setInfoClienteLocal', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCrearClienteLocal({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/personas/crearClienteLocal', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEditarClienteLocal({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/personas/editarClienteLocal', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAnularClienteLocal({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/personas/anularClienteLocal', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCategoriasPG({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/categoriasPG')
                    .then(response => {
                        commit('setCategoriasPG', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fecthPermisoCategoria({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/personas/permisosCategorias')
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fecthCrearPermisoCategoria({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/personas/crearPermisoCategoria', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fecthModificarPermisoCategoria({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/personas/modificarPermisoCategoria', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fecthEliminarPermisoCategoria({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/personas/eliminarPermisoCategoria', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
    },
}
